import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";

import TableHeadComp from "../../../pages/deals/view/TableHeadComp";
import { getPhonesHistory } from "../../../pages/deals/view/api";
import EmptyOrShow from "../../EmptyOrShow";

const PhoneChngHistory = ({ id }) => {
  const classes = useStyles();
  const [phones, setPhones] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    getPhonesHistory(id)
      .then((res) => {
        setPhones(res || []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <Box className={classes.history}>
      <EmptyOrShow loading={loading}>
        <TableContainer className={classes.table_container}>
          <Table size="small" aria-label="a dense table">
            <TableHeadComp data={titleArray} />
            <TableBody>
              {phones && phones.length > 0 ? (
                phones.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell align="center">{idx+1}</TableCell>
                    <TableCell align="center">{row?.fio}</TableCell>
                    <TableCell align="center">{row?.old_phone}</TableCell>
                    <TableCell align="center">{row?.new_phone}</TableCell>
                    <TableCell align="center">{row?.date_change}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">Нет истории изменений</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </EmptyOrShow>
    </Box>
  );
};

export default PhoneChngHistory;

const titleArray = [
  "№",
  "Кто изменил",
  "Старый телефон",
  "Новый телефон",
  "Дата изменения"
];

const useStyles = makeStyles({
  history: {
    width: 600,
    maxWidth: "90vw",
  },
  table_container: {
    scrollbarColor: "#6191EF #fff",
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      height: "7px",
    },
    "&::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#659DF1",
      borderRadius: 4,
    },
  },
});